import React from "react";
import { connect } from "react-redux";
import _ from "i18n";
import { formatAmount } from "../../../../services/utils";
import CircularProgressBar from "./CircularProgressBar";


const BudgetResult = ({ budgetManagement, type }) => {

  const calculateValues = () => {
    const { followUp, budgetPerMonth } = budgetManagement;
    const currentMonth = new Date().getMonth();
    const currentYear = new Date().getFullYear();

    const totalHTVA = followUp.reduce((acc, curr) => {
      if (type === 'budget') {
        return acc + curr.realizedHTVA
      } else {
        return acc + curr.totalHTVA
      }
    }, 0);
    const index = (currentYear == budgetManagement.year && type === 'budget') ? currentMonth : 11;
    let targetBudgetTotalHTVA = 0;
    for (let i = 0; i <= index; i++) {
      targetBudgetTotalHTVA += budgetPerMonth[i].totalHTVA;
    }

    const difference = totalHTVA - targetBudgetTotalHTVA;
    const percentage = targetBudgetTotalHTVA !== 0 ? ((difference / targetBudgetTotalHTVA) * 100).toFixed(1) : 0;

    return { totalHTVA, difference, percentage };
  };

  const getDate = () => {

    const selectedYear = budgetManagement.year;
    const currentDate = new Date();
    const currentYear = currentDate.getFullYear();
    let lastDayOfTheYear = new Date(selectedYear, 11, 31);

    let dateText;
    if (type === 'budget' && parseInt(selectedYear) === parseInt(currentYear)) {
      lastDayOfTheYear = currentDate;
      dateText = lastDayOfTheYear.toLocaleDateString('fr-FR', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric'
      });
    } else {
      dateText = lastDayOfTheYear.toLocaleDateString('fr-FR', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric'
      });
    }
    return dateText;
  };
  const { totalHTVA, difference, percentage } = calculateValues();

  return (
    <div className={'budget-result'}
      style={{ marginTop: type === 'adjustment' ? '20px' : '0px' }}>
      <h6
        className={'budget-result-titre'}>{type === 'budget' ? _('CURRENT_BUDGET_RESULT') : _('ANNUAL_ADJUSTMENT_RESULT')} : </h6>
      <h6 className="budget-result-titre">
        {_('FROM')} 01/01 {_('TO')} {getDate()}
      </h6>
      <p
        className={'budget-result-text mt-2 mb-2'}>{type === 'budget' ? _('COMPARISON_CA_TB') : _('COMPARISON_ADJUSTMENT_TB')}  </p>
      <div className={'budget-result-stats'}>
        <div className={'budget-result-total'}>
          <h6
            className={'budget-result-titre'}>{type === 'budget' ? _('TOTAL_REALIZED') : _('TOTAL_ADJUSTMENT')} :</h6>
          <h6 className={'budget-result-titre'}
            style={{ fontSize: '16px' }}>{formatAmount(totalHTVA, false)} </h6>
          <h6 className={'budget-result-titre'} style={{
            fontSize: '12px',
            color: difference >= 0 ? '#02AF8E' : '#FE3745'
          }}>
            {formatAmount(difference, false)}
          </h6>

        </div>
        <div style={{ width: '105px', height: '105px' }}>
          <CircularProgressBar percentage={percentage} />
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = state => ({
  budgetManagement: state.budgetManagement,
});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(BudgetResult);






// WEBPACK FOOTER //
// ./app/components/Admin/EventStats/BudgetManagement/BudgetResult.js